import { useLogo } from 'core/common/hooks';
import { FunnelImage } from 'core/flow/entities';
import { LoaderContainerStyled, ContainerStyled, LogoStyled, RotatingGalaxyStyled } from './styled';

type LoaderGalaxyProps = {
  loaderImage: FunnelImage;
};

export const LoaderGalaxy = ({ loaderImage }: LoaderGalaxyProps) => {
  const { logoSrc } = useLogo();

  return (
    <LoaderContainerStyled>
      <ContainerStyled>
        <LogoStyled src={logoSrc} height={100} width={154} alt="Nebula logo" />
        <RotatingGalaxyStyled
          src={loaderImage.src}
          alt={loaderImage.alt}
          width={280}
          height={280}
        />
      </ContainerStyled>
    </LoaderContainerStyled>
  );
};
